module.exports = __webpack_public_path__ + "static/media/falcon-mode-default.66875604.jpg";